module.exports = __webpack_public_path__ + "media/images/cross-white-d2677ff3.svg";